//Action Types
export var PETS_RESET_ACTION_TYPE = "PETS_RESET";
export var PETS_CLEAR_ACTION_TYPE = "PETS_CLEAR";
export var PETS_FETCH_START_ACTION_TYPE = "PETS_FETCH_START";
export var PETS_FETCH_SUCCESS_ACTION_TYPE = "PETS_FETCH_SUCCESS";
export var PETS_GET_START_ACTION_TYPE = "PETS_GET_START";
export var PETS_GET_SUCCESS_ACTION_TYPE = "PETS_GET_SUCCESS";
export var PETS_SAVE_MEDICAL_HISTORY_START_ACTION_TYPE = "PETS_SAVE_MEDICAL_HISTORY_START";
export var PETS_SAVE_MEDICAL_HISTORY_SUCCESS_ACTION_TYPE = "PETS_SAVE_MEDICAL_HISTORY_SUCCESS";
export var PETS_SAVE_VET_ID_START_ACTION_TYPE = "PETS_SAVE_VET_ID_START";
export var PETS_SAVE_VET_ID_SUCCESS_ACTION_TYPE = "PETS_SAVE_VET_ID_SUCCESS";
export var PETS_SAVE_START_ACTION_TYPE = "PETS_SAVE_START_ACTION_TYPE";
export var PETS_SAVE_SUCCESS_ACTION_TYPE = "PETS_SAVE_SUCCESS_ACTION_TYPE";
export var PETS_SAVE_IMAGE_START_ACTION_TYPE = "PETS_SAVE_IMAGE_START_ACTION_TYPE";
export var PETS_SAVE_IMAGE_SUCCESS_ACTION_TYPE = "PETS_SAVE_IMAGE_SUCCESS_ACTION_TYPE";
export var PETS_POST_NOTE_START_ACTION_TYPE = "PETS_POST_NOTE_START_ACTION_TYPE";
export var PETS_POST_NOTE_SUCCESS_ACTION_TYPE = "PETS_POST_NOTE_SUCCESS_ACTION_TYPE";
export var PETS_SAVE_VACCINE_START_ACTION_TYPE = "PETS_SAVE_VACCINE_START_ACTION_TYPE";
export var PETS_SAVE_VACCINE_SUCCESS_ACTION_TYPE = "PETS_SAVE_VACCINE_SUCCESS_ACTION_TYPE";
export var PETS_DELETE_VACCINE_START_ACTION_TYPE = "PETS_DELETE_VACCINE_START_ACTION_TYPE";
export var PETS_DELETE_VACCINE_SUCCESS_ACTION_TYPE = "PETS_DELETE_VACCINE_SUCCESS_ACTION_TYPE";
export var PETS_DELETE_MEDICAL_CONDITION_START_ACTION_TYPE = "PETS_DELETE_MEDICAL_CONDITION_START_ACTION_TYPE";
export var PETS_DELETE_MEDICAL_CONDITION_SUCCESS_ACTION_TYPE = "PETS_DELETE_MEDICAL_CONDITION_SUCCESS_ACTION_TYPE";
export var PETS_DELETE_START_ACTION_TYPE = "PETS_DELETE_START";
export var PETS_DELETE_SUCCESS_ACTION_TYPE = "PETS_DELETE_SUCCESS";
export var PETS_ACTIVATE_PET_START_ACTION_TYPE = "PETS_ACTIVATE_PET_START_START";
export var PETS_ACTIVATE_PET_SUCCESS_ACTION_TYPE = "PETS_ACTIVATE_PET_SUCCESS";
export var PETS_MARK_AS_DECEASED_START_ACTION_TYPE = "PETS_MARK_AS_DECEASED_START_START";
export var PETS_MARK_AS_DECEASED_SUCCESS_ACTION_TYPE = "PETS_MARK_AS_DECEASED_SUCCESS";
export var PETS_PRINT_PET_CARD_START_ACTION_TYPE = "PETS_PRINT_PET_CARD_START";
export var PETS_PRINT_PET_CARD_SUCCESS_ACTION_TYPE = "PETS_PRINT_PET_CARD_SUCCESS";
export var PETS_ERROR_ACTION_TYPE = "PETS_ERROR";
